enum Timezone {
  Local = "local",
  UTC = "UTC",
}

export default Timezone;

export const Timezones = [Timezone.Local, Timezone.UTC];
